<template>
  <!-- 单选选择器 -->
  <div class="single-selector">
    <el-button class="el-buttonsjg" @click.stop.once.prevent="select">
      <div class="singleWrapper">
        <div class="singleIcon">
          <div class="show"></div>
          <span
            class="oIcon"
            v-show="showAnswer"
            :class="isRight ? 'right' : 'error'"
          ></span>
        </div>
        <div class="conWrapper">
          <div class="sletter">
            <span class="oletter">{{ subNum }}.</span>
          </div>
          <div class="sdetail">
            <p class="odetail">{{ stitle }}</p>
          </div>
        </div>
      </div>
    </el-button>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { getIndex, getIndexM } from "@/libs/tools";
export default {
  name: "SingleSelector",
  props: ["stitle", "rightResult", "stitleNum", "canClick", "num"],
  data() {
    return {
      showAnswer: false,
    };
  },
  computed: {
    ...mapGetters({
      allSubjectList: "getAllsubjectList",
      allScores: "getAllScore",
      resultList: "getResultList"
    }),
    subNum() {
      return getIndexM(this.stitleNum);
    },
    isRight() {
      return this.rightResult.includes(this.subNum)
    },
  },
  methods: {
    ...mapMutations({
      updateList: "updateList",
      clearSubject: "clearSubject"
    }),
    select() {
      if (this.canClick) {
        console.log(this.isRight, this.subNum, this.stitleNum)
        this.updateList({value: this.subNum, num: this.num})
        this.$emit("selected", this.isRight, this.stitleNum);
      }
    },
    show() {
      this.showAnswer = true;
    },
    hide() {
      this.showAnswer = false;
    },
  },
  mounted() {
    if (this.resultList[this.num]) {
      this.showAnswer = true;
      this.canClick = false;
      // 清除记录
    }else {
      this.clearSubject(this.num)
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/common/scss/const.scss";
@import "~@/common/scss/mixin.scss";

.single-selector {
  width: 100%;
  margin-bottom: 5px;
  .el-buttonsjg {
    width: 100%;
    height: 80px; // 设置高度
    .singleWrapper {
      width: 100%;
      height: 20px;
      @include display-flex;
      @include flex-direction(row);
      // margin-top: pxToRem(10);
      margin-bottom: 15px;
      .singleIcon {
        @include flex(0 0 16px);
        width: 16px;
        padding-top: 1px;
        position: relative;
        .show {
          width: 16px;
          height: 16px;
          border: 1px solid #ccc;
          border-radius: 50%;
        }
        .oIcon {
          position: absolute;
          display: block;
          width: 16px;
          height: 16px;
          top: 1px;
          left: 0px;
          overflow: hidden;
          &.right {
            background: url("./images/right.png") no-repeat center center;
            background-size: 100% 100%;
            background-origin: center center;
            // 正方形错误提示（删除后变圆形）
            // background-color: #0064bf;
          }
          &.error {
            background: url("./images/error.png") no-repeat center center;
            background-size: 100% 100%;
            background-origin: center center;
            // 正方形错误提示（删除后变圆形）
            // background-color:#f42f2f;
          }
        }
      }
      .conWrapper {
        @include flex(1);
        @include display-flex;
        @include flex-direction(row);
        color: $color-font-sub;

        .sletter {
          padding: 0 10px;

          .oletter {
          }
        }
        .sdetail {
          @include flex(1);
          .odetail {
            text-align: left;
            // padding-bottom: 50px;
            // margin-left: 50px;
            // margin-bottom: 50px;
            // margin-left: 50px;
            // margin-l: 50px;
            height: 80px;
            // line-height: 10px;
            white-space: pre-wrap;
            word-break: break-all;
            word-wrap: break-word;
            //  overflow: hidden;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SingleSelector/SingleSelector.vue